import React from "react";
import { DetailRow, DetailSection } from "../../../ui/DetailRow";
import { StatusBadge } from "../../../ui";
import { Video, CreditCard } from "lucide-react";

/**
 * IntegrationsTab — Zoom & Razorpay status for an institute.
 */
const IntegrationsTab = ({ institute }) => {
  const inst = institute;
  const rz = inst.razorpay || {};
  const zm = inst.zoom || {};

  return (
    <div className="sa-detail-tab">
      {/* Zoom */}
      <DetailSection title="Zoom Integration">
        <DetailRow icon={Video} label="Mode" value={inst.zoomMode?.toUpperCase() || "V1"} />
        <DetailRow
          label="V1 Connection"
          value={
            <StatusBadge status={zm.connected ? "active" : "inactive"}>
              {zm.connected ? "Connected" : "Not Connected"}
            </StatusBadge>
          }
        />
        {zm.zoomEmail && <DetailRow label="V1 Zoom Email" value={zm.zoomEmail} />}
        <DetailRow
          label="V2 Connection"
          value={
            <StatusBadge status={zm.v2Connected ? "active" : "inactive"}>
              {zm.v2Connected ? "Connected" : "Not Connected"}
            </StatusBadge>
          }
        />
        {zm.v2ZoomEmail && <DetailRow label="V2 Zoom Email" value={zm.v2ZoomEmail} />}
        {zm.v2Mode && <DetailRow label="V2 Environment" value={zm.v2Mode} />}
        <DetailRow
          label="Auto-Create Meeting"
          value={zm.v2AutoCreateMeeting ? "Enabled" : "Disabled"}
        />
      </DetailSection>

      {/* Razorpay */}
      <DetailSection title="Razorpay Integration">
        <DetailRow
          icon={CreditCard}
          label="Status"
          value={
            <StatusBadge status={rz.enabled ? "active" : "inactive"}>
              {rz.enabled ? "Enabled" : "Disabled"}
            </StatusBadge>
          }
        />
        {rz.enabled && <DetailRow label="Mode" value={rz.mode?.toUpperCase() || "TEST"} />}
        {rz.enabled && <DetailRow label="Test Key" value={rz.testKeyId ? `${rz.testKeyId.slice(0, 12)}…` : "—"} />}
        {rz.enabled && rz.mode === "live" && (
          <DetailRow label="Live Key" value={rz.liveKeyId ? `${rz.liveKeyId.slice(0, 12)}…` : "—"} />
        )}
      </DetailSection>
    </div>
  );
};

export default IntegrationsTab;
